<template>
  <div class="vs-row">
    <vs-col vs-lg="12" vs-xs="12">
      <vs-card class="cardx">
        <vs-images>
          <vs-image
            :key="index"
            :src="image.url"
            v-for="(image, index) in imageList"
          />
        </vs-images>
      </vs-card>
    </vs-col>
  </div>
</template>
<script>

export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  data: function () {
    return {
      imageList: [
        {         
          url: require("@/assets/images/portfolio1.jpg"),
        },
        {         
          url: require("@/assets/images/portfolio2.jpg"),
        },
        {         
          url: require("@/assets/images/portfolio3.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio4.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio5.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio6.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio7.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio8.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio9.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio10.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio11.jpg"),
        },
         {         
          url: require("@/assets/images/portfolio12.jpg"),
        }
      ],
    };
  },
};
</script>